import { defineComponent as _defineComponent } from 'vue'
import {logout} from '@/api/passport/login';
import {Menu, useUser} from '@/pinia/modules/userData';
import {useRoute, useRouter} from '@/router';
import storage from 'baimahu/storage';
import SubMenu from "./SubMenu.vue";
import {onBeforeMount, ref, watch} from 'vue';
import {storeToRefs} from 'pinia';
import {useMenu} from "@/pinia/modules/menu";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAside',
  setup(__props) {

const router = useRouter();

const user = useUser();
const menu = useMenu();
const thisMenu = ref<(number | string)[]>([])


function thisMenuChange(val) {
  thisMenu.value = val
  user.thisMenuID = val?.[0]
}

function initMenu() {
  if (!user.thisMenuID) {
    thisMenu.value = []
    return
  }
  if (user.thisMenuID != thisMenu.value[0]) {
    thisMenu.value = [user.thisMenuID]
    user.setCache(user.thisMenu?.[0])
  }
}

//解决vue2.7 setup中的方法会执行两遍的bug
onBeforeMount(() => {
  //根据初始路由自动选择menu
  watch(
      [storeToRefs(user).thisSrc, storeToRefs(user).menu],
      (val) => {
        if (user.menu.length <= 0) {
          return
        }
        initMenu()
      }, {
        immediate: true
      });
})

function onSelect(keyValue: Menu | undefined) {
  // debugger
  if (!keyValue) {
    return
  }
  user.setCache(keyValue)
  if (keyValue.client_path) {
    router.push(String(keyValue.client_path)).catch(data => {
      // console.log('error',data);
    });
  }
}

function toDetail() {
  //
  router.push('/welcome/personal-information');
}

//退出登录
async function signOut() {
  const res = await logout();
  storage.removeItem('profile');
  user.clearCache()
  router.push('/login');
}

// (async () => {
//   //获取路由菜单
//   const menus = await getMenu();
//   user.setMenu(menus);
// })();
function stopClick() {
  storage.removeItem('profile');
  router.push('/login');
}

return { __sfc: true,router, user, menu, thisMenu, thisMenuChange, initMenu, onSelect, toDetail, signOut, stopClick, SubMenu }
}

})